"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceFormErrors = exports.replaceFormValues = exports.validateWithQuestionnaire = exports.forceAutosave = exports.enterFormValues = exports.syncFormValues = exports.clearAllQuestionnaires = exports.clearQuestionnaire = exports.initializeQuestionnaire = exports.ACTION_REPLACE_FORM_ERRORS = exports.ACTION_REPLACE_FORM_VALUES = exports.ACTION_VALIDATE_QUESTIONNAIRE = exports.ACTION_FORCE_AUTOSAVE = exports.ACTION_SYNC_FORM_VALUES = exports.ACTION_CLEAR_ALL = exports.ACTION_CLEAR = exports.ACTION_INITIALIZE = exports.ACTION_MOVE_ELEMENT_DOWN = exports.ACTION_MOVE_ELEMENT_UP = exports.ACTION_REMOVE_ELEMENT = exports.ACTION_INSERT_ELEMENT = exports.ACTION_ENTER_FORM_VALUES = exports.ACTION_SKIP_ANSWER = exports.ACTION_SET_VALUE = void 0;
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const questionnaire_1 = __importDefault(require("@zedoc/questionnaire"));
exports.ACTION_SET_VALUE = '@QUESTIONNAIRE/SET_VALUE';
exports.ACTION_SKIP_ANSWER = '@QUESTIONNAIRE/SKIP_ANSWER';
exports.ACTION_ENTER_FORM_VALUES = '@QUESTIONNAIRE/ENTER_FORM_VALUES';
exports.ACTION_INSERT_ELEMENT = '@QUESTIONNAIRE/INSERT_ELEMENT';
exports.ACTION_REMOVE_ELEMENT = '@QUESTIONNAIRE/REMOVE_ELEMENT';
exports.ACTION_MOVE_ELEMENT_UP = '@QUESTIONNAIRE/MOVE_ELEMENT_UP';
exports.ACTION_MOVE_ELEMENT_DOWN = '@QUESTIONNAIRE/MOVE_ELEMENT_DOWN';
exports.ACTION_INITIALIZE = '@QUESTIONNAIRE/INITIALIZE';
exports.ACTION_CLEAR = '@QUESTIONNAIRE/CLEAR';
exports.ACTION_CLEAR_ALL = '@QUESTIONNAIRE/CLEAR_ALL';
exports.ACTION_SYNC_FORM_VALUES = '@QUESTIONNAIRE/SYNC_FORM_VALUES';
exports.ACTION_FORCE_AUTOSAVE = '@QUESTIONNAIRE/FORCE_AUTOSAVE';
exports.ACTION_VALIDATE_QUESTIONNAIRE = '@QUESTIONNAIRE/VALIDATE_QUESTIONNAIRE';
exports.ACTION_REPLACE_FORM_VALUES = '@QUESTIONNAIRE/REPLACE_FORM_VALUES';
exports.ACTION_REPLACE_FORM_ERRORS = '@QUESTIONNAIRE/REPLACE_FORM_ERRORS';
const initializeQuestionnaire = (name, initialValues) => ({
    type: exports.ACTION_INITIALIZE,
    payload: initialValues,
    meta: {
        name,
    },
});
exports.initializeQuestionnaire = initializeQuestionnaire;
const clearQuestionnaire = (name) => ({
    type: exports.ACTION_CLEAR,
    meta: {
        name,
    },
});
exports.clearQuestionnaire = clearQuestionnaire;
const clearAllQuestionnaires = () => ({
    type: exports.ACTION_CLEAR_ALL,
});
exports.clearAllQuestionnaires = clearAllQuestionnaires;
const syncFormValues = (name, formValues, meta) => {
    if (formValues && !(0, isPlainObject_1.default)(formValues)) {
        throw Error(`Expected plain object or null, got ${typeof formValues}`);
    }
    return {
        type: exports.ACTION_SYNC_FORM_VALUES,
        payload: formValues,
        meta: Object.assign(Object.assign({}, meta), { name }),
    };
};
exports.syncFormValues = syncFormValues;
const enterFormValues = (name, formValues, meta) => {
    if (!(0, isPlainObject_1.default)(formValues)) {
        throw Error(`Expected plain object, got ${typeof formValues}`);
    }
    return {
        type: exports.ACTION_ENTER_FORM_VALUES,
        payload: formValues,
        meta: Object.assign(Object.assign({}, meta), { name }),
    };
};
exports.enterFormValues = enterFormValues;
const forceAutosave = (name) => ({
    type: exports.ACTION_FORCE_AUTOSAVE,
    meta: {
        name,
    },
});
exports.forceAutosave = forceAutosave;
const validateWithQuestionnaire = (name, value, meta) => {
    let rawQuestionnaire;
    if ((0, isPlainObject_1.default)(value)) {
        rawQuestionnaire = value;
    }
    else if (value instanceof questionnaire_1.default) {
        rawQuestionnaire = value.raw;
    }
    else if (value) {
        throw Error(`Expected plain object or Questionnaire, got ${typeof value}`);
    }
    return {
        type: exports.ACTION_VALIDATE_QUESTIONNAIRE,
        meta: Object.assign(Object.assign({}, meta), { rawQuestionnaire,
            name }),
    };
};
exports.validateWithQuestionnaire = validateWithQuestionnaire;
const replaceFormValues = (name, formValues = {}) => ({
    type: exports.ACTION_REPLACE_FORM_VALUES,
    payload: formValues,
    meta: {
        name,
    },
});
exports.replaceFormValues = replaceFormValues;
const replaceFormErrors = (name, formErrors = {}) => ({
    type: exports.ACTION_REPLACE_FORM_ERRORS,
    payload: formErrors,
    meta: {
        name,
    },
});
exports.replaceFormErrors = replaceFormErrors;
//# sourceMappingURL=actions.js.map